var render, staticRenderFns
import script from "./flash-message.vue?vue&type=script&lang=js"
export * from "./flash-message.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa0b94ba')) {
      api.createRecord('aa0b94ba', component.options)
    } else {
      api.reload('aa0b94ba', component.options)
    }
    
  }
}
component.options.__file = "resources/assets/js/components/flash-message.vue"
export default component.exports